/**
 * Developer passcode utility with obfuscation
 * Uses base64 encoding to obfuscate the passcode
 */

// Obfuscated passcode (base64 encoded "69420")
const OBFUSCATED_PASSCODE = "Njk0MjA=";

/**
 * Decode base64 string
 * @param str - Base64 encoded string
 * @returns Decoded string
 */
function decode(str: string): string {
  try {
    return atob(str);
  } catch {
    return '';
  }
}

/**
 * Verify if the provided passcode is correct
 * @param passcode - The passcode to verify
 * @returns True if passcode is correct, false otherwise
 */
export function verifyDevPasscode(passcode: string): boolean {
  const correctPasscode = decode(OBFUSCATED_PASSCODE);
  return passcode === correctPasscode;
}

/**
 * Check if dev access is already granted (stored in sessionStorage)
 * @returns True if access is granted, false otherwise
 */
export function hasDevAccess(): boolean {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem('dev_access') === 'granted';
}

/**
 * Grant dev access for the current session
 */
export function grantDevAccess(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem('dev_access', 'granted');
}

/**
 * Revoke dev access
 */
export function revokeDevAccess(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem('dev_access');
}
